'use strict';
//Jquery
//import $ from "jquery";
// jquery importuojamas globaliai webpack

//Bootstrap
//import Bootstrap from 'bootstrap';
//import "bootstrap/dist/css/bootstrap.css";

//Slick slider
import SlickSlider from 'slick-slider';
import "slick-slider/slick/slick.css";

//moment
import moment from 'moment';
moment.locale('lt');

//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";

//tooltipster
import Tooltipster from 'tooltipster';
import "tooltipster/dist/css/tooltipster.bundle.css";

import { Fancybox }
from "@fancyapps/fancybox";
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

import select2 from 'select2';
import "select2/dist/css/select2.css";

import 'jquery-validation';

import '../lib/lightgallery/js/lightgallery.ew4.js';

import '../lib/jquery-nicefileinput/jquery.nicefileinput.js';
import '../lib/javascript-equal-height-responsive-rows/grids.js';

import 'jquery.highlight-bartaz';

import { globalJsTranslations }
from '../services/globaljstranslations.js';
import { hashController }
from '../controllers/hashcontroller.js';

window.$ = $;

$(document).ready(function () {
	if (!$("#popup_window").length) { // init if not in dialog view
		select2init();
		fancybox();
		validate();
		slick_carousel();
		gallery_hash();
		youtube_hash();
		fixed_header();
		print_v();
		highlight_search_results();
		init_questions_toggler_hash();
		catalog_gallery();
		file_input();
		iframe_adaptability();
		show_more();
		postformwidget_validate();
		init_contacts();
		tooltipster();
		scroll_top();
		toggle_items();
		pikaday();
		sidebar();
		formWithKeyboard();
		searchToggle();
		blocksControl();
		blocksTabs();
	}
});

$(window).on('load', function () {
	$('.equalheight').responsiveEqualHeightGrid();
	if ($(window).width() < 768) {
		mobile_overflow_tables();
	}
	addAriaLabelToMobileMenu();
	$('textarea.g-recaptcha-response').attr('aria-label', 'recaptcha');
	$('li[role="menuitem"]').each(function () {
		$(this).find('a').attr('aria-label', 'direction-link');
	});

});

function select2init() {
	$("select").select2({
		"minimumResultsForSearch": -1
	});

	// use this class if placeholder is needed. 
	// Translation added as data attribute: <select data-placeholder="{'choise_value'|t}">
	// Also, first option in select element has to be empty: <option value=""></option>
	$("select.select2_with_dynamic_placeholder").select2({
		"minimumResultsForSearch": -1,
		placeholder: function () {
			$(this).data('placeholder');
		}
	});

	$("select.select2-multi").select2({
		"minimumResultsForSearch": -1,
		multiple: true,
		placeholder: "Pasirinkite",
		dropdownCssClass: 'multiselect',
		closeOnSelect: false
	});
	$('select.select2-multi').on('change', function (e) {
		$(".select2-selection__choice__remove").attr("tabindex", '0')
	});

	

	$('select.select2-multi').each(function(elem){
		if(($(this).val()).length > 0) {
			$(this).addClass("options-selected");
		} else {
			$(this).removeClass("options-selected");
		}
	});

	$("select.select2-multi").on('change', function(e) {
		if(($(this).val()).length > 0) {
			$(this).addClass("options-selected");
		} else {
			$(this).removeClass("options-selected");
		}
	});
}

function slick_carousel() {
	// Slick carousel docs:
	//http://kenwheeler.github.io/slick/

	if ($("#title_slides").length) {
		$('#title_slides').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			rows: 0
		});

		$('#title_slides').on('afterChange', function (event, slick, currentSlide, nextSlide) {
			//console.log(slick);
		});
	}

	if ($(".promoblock_slider").length) {
		$('.promoblock_slider').slick({
			dots: false,
			arrows: true,
			infinite: true,
			slidesToShow: 6,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 420,
					settings: {
						slidesToShow: 2,
					}
				}],
			slidesToScroll: 1,
			speed: 180,
			cssEase: 'linear',
			rows: 0
		});
	}

	if ($(".s--banners .banners-slider").length) {
		$('.s--banners .banners-slider').slick({
			dots: false,
			arrows: true,
			slidesToScroll: 1,
			centerMode: true,
			lazyLoad: 'ondemand',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 1,
					}
				},
			],
		});
	}

	if ($(".s--links .links-block > div").length) {
		$(".s--links .links-block > div").slick({
			dots: false,
			arrows: true,
			slidesToScroll: 1,
			//centerMode: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 550,
					settings: {
						slidesToShow: 1,
					}
				},
			],
		});
	}

	if ($(".s--slidesvideos .slider").length) {
		$('.s--slidesvideos .slider').slick({
			lazyLoad: 'ondemand',
			dots: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			swipe: false,
			autoplay: false,
			speed: 0
		});
		$(".slider").on("lazyLoaded", function(e, slick, image, imageSource){
			var desktop_image = image.data('desktop');
			var mobile_image = image.data('mobile');
			image.attr('src','data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
		   
			//set the correct image based on size of screen
			imageSource = desktop_image;
			if($(window).width()<768){
			  imageSource = mobile_image;
			}
			image.attr('src',imageSource);
		});
	}

	if ($(".gallery-preview-slider").length) {
		$('.gallery-preview-slider').slick({
			dots: false,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.gallery-nav-slider'
		});
	}

	if ($(".gallery-nav-slider").length) {
		$('.gallery-nav-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.gallery-preview-slider',
  			focusOnSelect: true
		});
	}
}


function fancybox() {
	// FB3 docs: https://fancyapps.com/fancybox/3/docs
	//  Translations inside libs/localization/

	// News preview
	$("a.image").fancybox({
		btnTpl: {
			zoom: false
		}
	});

	// News gallery 
	$("a.fancybox_gallery").fancybox({
		thumbs: false,
		transitionEffect: "slide",
		clickContent: false,
		btnTpl: {
			zoom: false
		}
	});

	// From Tinymce
	$("a[rel=fancybox]").fancybox({
		btnTpl: {
			zoom: false
		}
	});
	// From Tinymce
	$("a[rel=fancybox-images]").fancybox({
		btnTpl: {
			zoom: false,
			slideShow: false,
			thumbs: false,
		}
	}).attr('data-fancybox', 'images');

	// Ajax call
	$("a.fancybox_ajax").fancybox({
		type: "ajax",
		touch: false // disable drag cursor
	});

	// Iframe call
	$("a.fancybox_iframe").fancybox({
		type: "iframe",
		touch: false // disable drag cursor
	});
}

function gallery_popup() {
	$('.gallery_popup').on("click", function () {
		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				$.each(data.photos, function (i) {
					var obj = {
						"src": this.img_itemimage,
						"thumb": this.img_itemimage_thumb
					};
					if (this.title) {
						obj.subHtml = '<div class="photo_title">' + this.title + '</div>';
					}
					photos.push(obj);
				});
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					galleryId: $this.data("id")
				});
				$this.on('onAfterOpen.lg', function (event, index, fromTouch, fromThumb) {
					$(".lg").append("<div class='album_title lg-toolbar'><div class='album_title_text'>" + data.title + "</div></div>")
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}

function youtube_popup() {
	$('.youtube_popup').on("click", function () {

		$(".album_loading").show();
		var $this = $(this);
		var url = $(this).data("fancy-link");
		$.ajax({
			url: url,
			type: "GET",
			success: function (data) {
				$(".album_loading").fadeOut("fast");
				var photos = [];
				var obj = {
					"src": data.youtube_share_link,
					"thumb": data.img_itemimage_thumb,
					//"poster":  data.img_itemimage_thumb
				};
				if (data.title) {
					obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
				}
				photos.push(obj);
				$this.lightGallery({
					dynamic: true,
					dynamicEl: photos,
					speed: 300,
					hideBarsDelay: 1000,
					closable: false,
					loop: false,
					download: false,
					enableDrag: false,
					thumbWidth: 112,
					thumbContHeight: 83,
					thumbMargin: 10,
					toogleThumb: false,
					//youtubePlayerParams: {autoplay:0 },
					counter: false,
					videoMaxWidth: '900px',
					addClass: "youtubegallery_popup",
					fullScreen: false
				});
			},
			error: function () {
				$(".album_loading").fadeOut("fast");
				alert('Load error.');
			}
		});


	});
}


function validate() {
	// Determine the language
	var langAttribute = $('html').attr('lang') || 'en';

	// Define language-specific error messages
	var errorMessages = {
		en: {
			required: "This field is requiredssssss.",
			// Add more messages for other validation rules as needed
		},
		// Add more languages as needed
	};
	var options = {
		highlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(validClass).addClass(errorClass);
			}
		},
		unhighlight: function (element, errorClass, validClass) {
			if ($(element).closest(".type_item").length) {
				$(element).closest(".type_item").removeClass(errorClass).addClass(validClass);
			}
		},
		errorPlacement: function (error, element) {
			$(element).closest(".type_item").find('.type_error').append(error);
		},
	}
	if ($("#forms_form").length) {
		$("#forms_form").validate(options);
		$("#forms_form select").change(function () {
			$(this).valid();
		});
		$("#forms_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#letter_form").length) { // Postform
		$("#letter_form").validate(options);
	}
	if ($("#poll_form").length) {
		$("#poll_form").validate(options);
		$("#poll_form select").change(function () {
			$(this).valid();
		});
		$("#poll_form input[type='file']").change(function () {
			$(this).valid();
		});
	}
	if ($("#subscription_form").length) {
		$("#subscription_form").validate(options);
	}
	if ($("#poll_widget").length) {
		$("#poll_widget").validate(options);
	}
	if ($("#sitelogin_widget").length) {
		$("#sitelogin_widget").validate(options);
	}
	if ($("#duk_form").length) {
		$("#duk_form").validate(options);
	}
	if ($(".comment-form").length) {
		$(".comment-form").validate(options);
	}
	if ($("#sitelogin_form").length) {
		$("#sitelogin_form").validate(options);
	}
	if ($("#faq_form").length) {
		$("#faq_form").validate(options);
	}
	if ($("#subscription_form_index").length) {
		$("#subscription_form_index").validate(options);
	}
	if ($("#remind_pass_form").length) {
		$("#remind_pass_form").validate(options);
	}

	if ($('#custom_validate').length) {
		$("#custom_validate").validate(options);
		$("#custom_validate select").change(function () {
			$(this).valid();
		});
		$("#custom_validate input[type='file']").change(function () {
			$(this).valid();
		});
	}
}

/**
 * Alias for hashController
 * @type @exp;hashController
 */
window.hc = hashController;

/**
 * @example hc.register({callback: function(e, h){
 *			console.log(h.get());
 *		}});
 *
 *		hc.set('raudona');
 */

$(document).ready(function () {
	hc.trigger();
});

function galleryWrapper() {
	this.photos = new Array();
	this.album_data;
	this.album_id;
	this.photo_id = '';
	this.dataUrl = '';
	this.isOpen = false;
	this.base_url = location.pathname + '/';
	this.hcb;

	this.gallery_options = {
		dynamic: true,
		speed: 300,
		hideBarsDelay: 2000,
		closable: false,
		loop: true,
		download: false,
		enableDrag: false,
		thumbWidth: 112,
		thumbContHeight: 93,
		thumbMargin: 10,
		showAfterLoad: false,
		toogleThumb: false,
		galleryId: this.album_id
	};

	if (arguments[0] && typeof (arguments[0]) === 'object') {
		$.extend(this.gallery_options, arguments[0]);
	}

	var self = this;

	this.getElement = function () {
		if (!document.getElementById(this.album_id)) {
			$('body').append('<div id="' + this.album_id + '" style="display:none;"></div>');
		}
		return $('#' + this.album_id);
	};

	this.init = function () {
		if (!this.isOpen) {
			$(".album_loading").show();
			$.ajax({
				url: this.dataUrl,
				type: "GET",
				dataType: "json",
				contentType: "application/json",
				success: function (data) {
					self.album_data = data;
					self.setPhotos(data);
					if (self.photos.length > 0) {
						self.initgallery();
						$(".album_loading").fadeOut("fast");
					} else {
						$(".album_loading").fadeOut("fast");
						self.close();
					}
				},
				error: function () {
					$(".album_loading").fadeOut("fast");
					alert('Load error.');
				}
			});
		}
	};

	this.setPhotos = function (data) {
		if (typeof (data.photos) !== 'undefined') {
			for (var i = 0; i < data.photos.length; i++) {
				var obj = {
					src: ($(window).width() > 800 ? data.photos[i].img__original : data.photos[i].img_itemimage)
				};
				if (typeof (data.photos[i].img_itemimage_thumb) !== 'undefined') {
					obj.thumb = data.photos[i].img_itemimage_thumb;
				} else {
					obj.thumb = data.photos[i].img_listimage;
				}
				if (data.photos[i].title) {
					obj.subHtml = '<div class="photo_title">' + data.photos[i].title + '</div>';
				}
				self.photos.push(obj);
			}
		}
	};

	this.initgallery = function () {
		var cont = this.getElement();
		if (this.photo_idx > 0 && this.photos.length > this.photo_idx) {
			this.gallery_options.index = this.photo_idx;
		}
		this.gallery_options.dynamicEl = this.photos;
		this.gallery_options.galleryId = this.album_id;
		$(cont).lightGallery(this.gallery_options);
		this.isOpen = true;
		this.galleryEvents(cont);
	};

	this.galleryEvents = function (cont) {
		$(cont).on('onAfterOpen.lg', function () {
			if ($("#album_title").length) {
				$("#album_title").html(self.album_data.title);
			} else {
				$(".lg").append("<div class='album_title lg-toolbar'><div id='album_title' class='album_title_text'>" + self.album_data.title + "</div></div>");
			}
			if (!$(".gallery_share").length) {
				$(".lg-toolbar.group").append("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>");
				//$("<div class='gallery_share'><div class='share_icon'></div><div class='share_drop'><div class='share_fb'></div><div class='share_gplus'></div></div></div>").insertAfter(".lg-fullscreen");

				$(".lg-outer").on("click", function () {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
				});
				$(".share_icon").on("click", function (e) {
					$(this).addClass("active");
					e.stopPropagation();
					$(this).parent().find(".share_drop").slideToggle("fast");
				});

				$(".share_fb").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://www.facebook.com/sharer/sharer.php?u=" + escape(window.location.href), 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
				$(".share_gplus").on("click", function (e) {
					$(".share_drop").slideUp("fast");
					$(".share_icon").removeClass("active");
					window.open("https://plus.google.com/share?url=" + escape(window.location.href), '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
					return false;
				});
			}
			if (self.photo_idx > 0) {
				$(cont).data('lightGallery').slide(self.photo_idx);
			}
		});
		$(cont).on('onCloseAfter.lg', function () {
			self.hcb.hashObj.clear();
			self.close();
		});
		$(cont).on('onAfterSlide.lg', function (event, index, fromTouch, fromThumb) {
			self.hcb.hashObj.replace('!' + self.album_id + '/photo' + $(cont).data('lightGallery').index);
//			setTimeout(function(){self.ignore(false);}, 50);
		});
	};

	this.route = function (e, hcb) {
		this.hcb = hcb;
		var parts = this.hcb.hashObj.get().replace(/^\!/, '').split('/');
		this.album_id = parts[0];

		this.dataUrl = this.getUrl();

		this.ignore(true);
		if (parts.length > 1 && /^photo[0-9]+$/.test(parts[1])) {// && typeof(this.photos_index[parts[1]]) !== 'undefined'){
			var nr = parts[1].replace(/^photo([0-9]+)$/, '$1');
			if (!this.isOpen && this.photo_idx != nr) {
				this.photo_idx = parseInt(nr);
			}
//			else if(this.isOpen){
//				var cont = this.getElement();
//				console.log(parseInt(nr));
//				$(cont).data('lightGallery').slide(parseInt(nr));
//			}
		}
		if (!this.isOpen) {
			this.init();
		}
	};

	this.close = function () {
		this.ignore(false);
		this.photos = new Array();
		this.album_data = null;
		this.album_id = '';
		this.dataUrl = '';
		this.photo_idx = '';
		this.isOpen = false;
		//this.hcb = null;
	};

	this.ignore = function () {
		this.hcb.lock = !!arguments[0];
	};
	this.isIgnored = function () {
		return !!this.hcb.lock;
	};
	this.getUrl = function () {
		var url = this.getElement().data('url');
		if (!url || url === '') {
			url = this.base_url + this.album_id;//location.pathname + '/albumdata/' + this.album_id;
		}
		return url;
	};
	//this.route();
}
;

function gallery_hash() {
	var wr = new galleryWrapper();
	wr.base_url = location.pathname + '/albumdata/';
	hc.register({
		callback: function (e, hcb) {
			wr.route(e, hcb);
		},
		rule: new RegExp("^\!album[0-9]+(/photo[0-9]+)*$")
	});
	$('.gallery-list-js, .search-results, .assoc_gallery_cont').on("click keypress", ".gallery-item-js", function (event) {
		if (event.type === 'click' || (event.type === 'keypress' && event.which === 13)) {
			location.hash = '!' + $(this).attr('id');
		}
	});

}

function youtube_hash() {

	var wry = new galleryWrapper({
		loop: false,
		youtubePlayerParams: {
			//autoplay: 0,
			rel: 0/*,
			 showinfo: 0*/
		},
		counter: false,
		videoMaxWidth: '900px',
		addClass: "youtubegallery_popup",
		fullScreen: false
	});

	wry.base_url = location.pathname + '/itemdata/';

	wry.setPhotos = function (data) {
		var obj = {
			src: data.youtube_share_link,
			thumb: data.imgthumbnail//,
					//poster: data.imgposter // reikalingas jei norim autoplay=0
		};
		if (data.title) {
			obj.subHtml = '<div class="photo_title">' + data.title + '</div>';
		}
		wry.photos.push(obj);
	};

	wry.galleryEvents = function (cont) {
		$(cont).on('onCloseAfter.lg', function () {
			wry.hcb.hashObj.clear();
			wry.close();
		});
	};

	hc.register({
		callback: function (e, hcb) {
			wry.route(e, hcb);
		},
		rule: new RegExp("^\!yt[0-9]+$")
	});
	$('.gallery-item-js, .search-results, .assoc_gallery_cont').on("click keypress", ".youtube-item-js", function (event) {
		if (event.type === 'click' || (event.type === 'keypress' && event.which === 13)) {
			location.hash = '!' + $(this).attr('id');
		}
	});
}

function getMoreNews(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.news_list').append(html);
		imagesLoaded($('.news_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreAlbums(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.gallery_list').append(html);
		imagesLoaded($('.gallery_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}

function getMoreVideos(url) {
	$('.more_btn_cont').remove();
	$('.loader_content').show();
	$.ajax({
		url: url,
		cache: false
	}).done(function (html) {
		$('.youtube_list').append(html);
		imagesLoaded($('.youtube_list'), function () {
			equalheight_list_items('.equalheight');
		});
		$('.loader_content').hide();
	});
}


window.isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function () {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	}
};


function fixed_header() {
	$('.container-fluid').click(function () {
		$(".langs_drop_cont").slideUp("fast");
		$(".langs_cont").removeClass("dropped");
	});

	$(".current_lang_cont").click(function (e) {
		e.stopPropagation();
		$(this).parent().toggleClass("dropped");
		$(this).parent().find(".langs_drop_cont").slideToggle("fast");
	});

	// Fixes the fixed header in iOS
	if (isMobile.iOS()) {
		var $body;
		if ('ontouchstart' in window) {
			$body = $("body");
			document.addEventListener('focusin', function () {
				return $body.addClass("fixfixed");
			});
			return document.addEventListener('focusout', function () {
				$body.removeClass("fixfixed");
				return setTimeout(function () {
					return $(window).scrollLeft(0);
				}, 20);
			});
		}
	}

}

function print_v() {
	$(".print_button").click(function () {
		window.print();
	});
}

function highlight_search_results() {
	if ($('#search_results_container').length > 0) {
		var query = $('#search_results_container').attr('data-text');
		if (typeof (query) !== 'undefined' && query !== '') {
			$('#search_results_container').highlight(query);
		}
	}

}

function init_questions_toggler_hash() {

	var $ct = $('.category-title');
	var $tt = $('.topic-title');
	var offset = ($('.fixed_header').is(':visible')) ? 50 : 0;

	var self = this;

	function getArgs() {
		var query = window.location.hash;
		query = query.substr(1)
		var args = new Array();
		query.split("/").forEach(function (part) {
			var item = part.split("-");
			args[item[0]] = item[1];
		});
		return args;
	}

	var args = getArgs();

	if (typeof args['c'] !== 'undefined') {
		$('[data-category-id="' + args['c'] + '"]').find('.category-title').attr('data-category-role', 'open').next('.topics').removeClass('hidden').addClass('visible');
		$('[data-category-id="' + args['c'] + '"]').next('.topics').slideDown("fast");
	}

	if (typeof args['t'] !== 'undefined') {
		$('[data-topic-id="' + args['t'] + '"]').attr('data-topic-role', 'open').next('.topic-description').removeClass('hidden').addClass('visible');
		$('[data-topic-id="' + args['t'] + '"]').next('.topic-description').slideDown("fast");
	}

	function hide(sel) {
		return sel.slideUp("fast").removeClass('visible').addClass('hidden');
	}

	function show(sel) {
		return sel.slideDown("fast").removeClass('hidden').addClass('visible');
	}

	function ctEvent() {
		$ct.on('click keypress', function (e) {
			if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
				if ($(this).attr('data-category-role') === 'close') {
					var cur = $(this);
					hide($ct.attr('data-category-role', 'close').next('.topics')).not($(this));
					hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
					show($(this).attr('data-category-role', 'open').next('.topics'));
					window.location.hash = '#c-' + $(this).attr('data-category-id');
				} else if ($(this).attr('data-category-role') === 'open') {
					hide($ct.attr('data-category-role', 'close').next('.topics'));
					hide($tt.attr('data-topic-role', 'close').next('.topic-description'));
					hide($(this).attr('data-category-role', 'close').next('.topics'));
					history.pushState("", document.title, window.location.pathname + window.location.search);
				}
			}
		});
	}

	function ttEvent() {
		$tt.on('click keypress', function (e) {
			if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {

				if ($(this).attr('data-topic-role') === 'close') {
					var cur = $(this);
					hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');
					hide($tt.parent('.topics:not(.show)').not($(this).parent()));
					$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
					hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));
					show($(this).attr('data-topic-role', 'open').next('.topic-description'));
					history.pushState("", document.title, window.location.pathname + window.location.search + '#c-' + $(this).attr('data-category-id') + '/' + 't-' + $(this).attr('data-topic-id'));
				} else if ($(this).attr('data-topic-role') === 'open') {
					hide($('.no-topics')).prev('.category-title').attr('data-category-role', 'close');
					hide($tt.parent('.topics:not(.show)').not($(this).parent()));
					$tt.parent().prev('.category-title').not($(this).parent().prev('.category-title')).attr('data-category-role', 'close');
					hide($tt.not($(this)).attr('data-topic-role', 'close').next('.topic-description').not($(this).next('.topic-description')));
					hide($(this).attr('data-topic-role', 'close').next('.topic-description'));
					window.location.hash = '#c-' + $(this).attr('data-category-id');
				}
			}
		});
	}

	function initEvents() {
		ctEvent();
		ttEvent();
	}

	initEvents();
}


function catalog_gallery() {
	$(".catalog_gallery a").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		$(".catalog_gallery a").removeClass("active_ph");
		$(this).addClass("active_ph");
		$("a.full_photo_preview").removeClass("current_photo");
		$(".main_photo a.photo" + $(this).data("href")).addClass("current_photo");
	});
}


function file_input() {
	$("input[type=file]").nicefileinput({});
}

function mobile_overflow_tables() {
	if ($(".content_template").length) {
		$('.content_template table').each(function () {
			var element = $(this);
			// Create the wrapper element
			var scrollWrapper = $('<div />', {
				'class': 'scrollable',
				'html': '<div />' // The inner div is needed for styling
			}).insertBefore(element);
			// Store a reference to the wrapper element
			element.data('scrollWrapper', scrollWrapper);
			// Move the scrollable element inside the wrapper element
			element.appendTo(scrollWrapper.find('div'));
			// Check if the element is wider than its parent and thus needs to be scrollable
			if (element.outerWidth() > element.parent().outerWidth()) {
				element.data('scrollWrapper').addClass('has-scroll');
			}
			// When the viewport size is changed, check again if the element needs to be scrollable
			$(window).on('resize orientationchange', function () {
				if (element.outerWidth() > element.parent().outerWidth()) {
					element.data('scrollWrapper').addClass('has-scroll');
				} else {
					element.data('scrollWrapper').removeClass('has-scroll');
				}
			});
		});
	}
}

function iframe_adaptability() {

	var $container = $(".content_template");
	var $iframes = $("iframe");

	$container.find($iframes).each(function () {
		$(this).wrap("<div class='iframe_wrapper'></div>");
	});
}

function show_more() {
	$('.blocks_container').find('.show_more').click(function () {
		$(this).toggleClass('active');
		$(this).parent('.text_container').next('.block_more_info').slideToggle('fast').toggleClass('open');
	});

	$('.blocks_container').find('.show_less').click(function () {
		$(this).parents('.single_block').find('.show_more').removeClass('active');
		$(this).parent('.block_more_info').slideUp('fast').removeClass('open');
	});

	$('.videos_list').find('.show_video_desc').click(function () {
		$(this).toggleClass('active');
		$(this).next('.resource_video_desc').slideToggle('fast');
	});
}

function postformwidget_validate() {
	var $form = $("#postformwidget_form");
	if ($form.length) {
		$form.validate({
			submitHandler: function (form) {
				if ($form.hasClass("currently_sending")) {
					return false;
				}
				var data = $(form).serialize();
				var url = $(form).data("url");
				$form.addClass("currently_sending");
				$.ajax({
					type: "POST",
					url: url,
					data: data,
					success: function (data) {
						$form.removeClass("currently_sending");
						var $infoc = $(".postformwidget_infos");
						$infoc.find(".info_cont").fadeOut("fast").html();
						$infoc.find(".error_cont").fadeOut("fast");
						$infoc.find(".error_cont .errors_list").html();
						if (!data.data.success) {
							$infoc.fadeIn("fast");
							$infoc.find(".error_cont").fadeIn("fast").find(".errors_list").html('<p>' + data.data.errors.join("</p><p>") + '</p>');
						} else {
							$infoc.fadeIn("fast");
							$infoc.find(".info_cont").fadeIn("fast").html('<p>' + data.data.message + '</p>');
							$form.find("input").val('');
							$form.find("textarea").val('');
							$form.find(".input_holder").fadeOut("fast");
							$form.find(".contact_block_title").fadeOut("fast");
							$form.find(".recaptcha_cont").fadeOut("fast");
							$form.find(".button_holder").fadeOut("fast");
							setTimeout(function () {
								$(window).trigger('resize');
							}, 450);
						}
					}
				});
				return false;
			}
		});
	}
}

function init_contacts() {
	if ($(".contacts_struct_cont").length) {
		$('#search_by_field').change(function () {
			$('#search_by_label').text($("#search_by_field option[value='" + $(this).val() + "']").text());
		});
	}
}

// http://iamceege.github.io/tooltipster/
function tooltipster() {
	if ($(".tooltip").length) {
		$('.tooltip').tooltipster({
			delay: 15,
			side: 'right',
			position: 'right'
		});
	}
	if ($(".tooltip--project").length) {
		$('.tooltip--project').tooltipster({
			delay: 15,
			side: 'right',
			position: 'right',
			theme: 'projects-theme',
		});
	}
}

function scroll_top() {
	if ($('.scroll_top').length > 0) {
		$('.scroll_top button').click(function () {
			$('html, body').animate({
				scrollTop: 0
			}, 300);
		});
	}
}

function toggle_items() {
	$('.btn_toggle').click(function () {
		$(this).parent().parent().find('.toggle_content').toggleClass('active');
		$(this).toggleClass('rotate');
	});
}

function addAriaLabelToMobileMenu() {
	var elementsList = document.querySelectorAll('a.mm-next');

	if (elementsList.length < 1) {
		return;
	}

	for (var i = 0; i < elementsList.length; i++) {
		var element = elementsList[i];
		element.setAttribute('aria-label', globalJsTranslations().getTr('next'));
	}
}

function pikaday() {
	// Get all elements with the class 'datepicker'
	var datepickerElements = $('.datepicker');

	// Loop through each datepicker element
	datepickerElements.each(function (index, element) {
		// Get the lang attribute value from the HTML tag
		var langAttribute = $('html').attr('lang') || 'en'; // Default to 'en' if lang attribute is not present

		// Set the locale for moment.js based on the lang attribute
		moment.locale(langAttribute);

		// Create a new Pikaday instance for each datepicker element
		var picker = new Pikaday({
			field: element,
			format: 'YYYY-MM-DD', // Adjust the date format as needed
			i18n: {
				months: moment.months(),
				weekdays: moment.weekdays(),
				weekdaysShort: moment.weekdaysShort(),
			},
			// Other Pikaday options...
		});
	});
}

function sidebar() {
// JavaScript code for submenu toggling
	// Get all submenu links with a class of "has-childs"
	const submenuLinks = document.querySelectorAll(".submenu__a.has-childs");

	// Loop through each submenu link
	submenuLinks.forEach((link) => {
		// Get the .icon element within the submenu link
		const icon = link.querySelector(".icon");

		// Add a click event listener to the icon
		icon.addEventListener("click", function (event) {
			// Prevent the default click behavior of the icon
			event.preventDefault();

			// Toggle the "opened" class for the parent submenu link
			link.classList.toggle("active");
			link.parentNode.classList.toggle("active");
			// Get the submenu list associated with this link
			const submenuList = link.nextElementSibling;
			// Toggle the "active" class for the submenu list
//			submenuList.classList.toggle("active");
		});
		icon.addEventListener("keydown", function (event) {
			if(event.keyCode == 13) {
				event.preventDefault();
				link.classList.toggle("active");
				link.parentNode.classList.toggle("active");
				const submenuList = link.nextElementSibling;
			}
		});
	});
}

function formWithKeyboard() {
	$('.NFI-filename').keydown(function (e) {
		if (e.keyCode === 13) { // Check if the pressed key is Enter (key code 13)
			// Find the associated file input element and trigger a click event
			$(this).parent().find('.NFI-current').click();
		}
	});
	$('.NFI-filename').attr('aria-label', 'filename');
	var langAttribute = $('html').attr('lang');
	var uploadText;

	switch (langAttribute) {
		case 'en':
			uploadText = "Upload file";
			break;
		case 'ru':
			uploadText = "Загрузить файл";
			break;
		case 'lv':
			uploadText = "Augšupielādēt failu";
			break;
		case 'pl':
			uploadText = "Prześlij plik";
			break;
		case 'ua':
		case 'uk':
			uploadText = "Завантажити файл";
			break;
		default:
			uploadText = "Įkelti"; // Default value
	}

	$('.NFI-filename').val(uploadText);

	const form = document.querySelector("#forms_form,#poll_form,#subscription_form_index,#user_info-form");
	if (form) {
		const button = document.querySelector("button[type='submit']");

		form.addEventListener("keypress", function (event) {
			// Check if the Enter key was pressed (keyCode 13) and if the submit button is not focused
			if (event.keyCode === 13 && document.activeElement !== button) {
				event.preventDefault(); // Prevent form submission
			}
		});
	}

	// Select all radio and checkbox buttons with the same name attribute
	const checkButtons = document.querySelectorAll('input[type="checkbox"]');

	checkButtons.forEach(function (checkButton) {
		checkButton.addEventListener('keydown', function (event) {

			// Check if the Enter key (keyCode 13) was pressed
			if (event.keyCode === 13) {
				// Toggle the checked state of the clicked radio button
				checkButton.checked = !checkButton.checked;
			}
		});
	});
}

function searchToggle() {
	let body = $('body');
	let btn = $('.search-toggle');
	let formWrapper = $('.top-search-wr');

	btn.click(function () {
		formWrapper.toggleClass("active");
		body.toggleClass("overflow-hidden");
	});

	// Handle clicks outside the formWrapper
	$(document).mouseup(function (e) {
		// If the clicked element is not a child of formWrapper
		if (!formWrapper.is(e.target) && formWrapper.has(e.target).length === 0) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
	// Handle ESC key press
	$(document).keyup(function (e) {
		// If ESC key is pressed and the formWrapper is active
		if (e.keyCode === 27 && formWrapper.hasClass("active")) {
			formWrapper.removeClass("active");
			body.removeClass("overflow-hidden");
		}
	});
}

function blocksControl() {
	if ($('.show-more-blocks').length > 0) {
		let showMoreButton = document.querySelector('.show-more-blocks');
		let showLessButton = document.querySelector('.show-less-blocks');
		let additionalLinks = document.querySelector('.toggleable-blocks');

		// Function to toggle visibility of additional links
		function toggleAdditionalLinks() {
			additionalLinks.classList.toggle('hidden');
		}

		// Event listener for "View More" button
		showMoreButton.addEventListener('click', function () {
			toggleAdditionalLinks();
			showMoreButton.style.display = 'none';
			showLessButton.style.display = 'block';
		});

		// Event listener for "Show Less" button
		showLessButton.addEventListener('click', function () {
			toggleAdditionalLinks();
			showLessButton.style.display = 'none';
			showMoreButton.style.display = 'block';
		});
	}
}

function blocksTabs() {
	$('.tabs .tabs__nav .tabs__btn').on("click keydown", function (e) {
		if (e.type == "click" || e.keyCode == 13) {
			var t = $(this).attr('id');
			if ($(this).hasClass('active')) {
				return;
			} else {
				$('.tabs .tabs__nav .tabs__btn.active').removeClass('active');
				$(this).addClass('active');
				$('.tabs .tabs__cont').hide();
				$('#' + t + 'C').fadeIn('slow');
			}
		}
	});
}
